
export class Role {
  public roleID: number;
  public roleName: string;
  public description: string;
  public isActive: boolean;
  public createdDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/models/shared/role.model.ts